import { render, staticRenderFns } from "./FormContactSupplier.vue?vue&type=template&id=6d7f3f63&"
import script from "./FormContactSupplier.vue?vue&type=script&lang=ts&"
export * from "./FormContactSupplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7f3f63')) {
      api.createRecord('6d7f3f63', component.options)
    } else {
      api.reload('6d7f3f63', component.options)
    }
    module.hot.accept("./FormContactSupplier.vue?vue&type=template&id=6d7f3f63&", function () {
      api.rerender('6d7f3f63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/FormContactSupplier.vue"
export default component.exports